import React from "react";
import Image from "components/image";
import clsx from "clsx/lite";
import DoubleQuote from "assets/images/double-quote.png";
import { isMobile } from "utils/device-detect";
import { getRgba } from "helpers/get-rgba";
import { formatTitle } from "helpers/format-title";

const ExpertQuote = ({ data, isSlider = false }) => {
	const { title, bgColor, expertTitle, expertName, quote, image, logo, showOriginalImg,
		imageRight, hideDoubleQuote, contentTop, mobileImage, bgImage, largerFont, constrainedWidth,
		topAlignExpertDetails, showTitleAboveName } = data;
	const mobileView = isMobile();
	const img = (mobileView && mobileImage) ? mobileImage : image;

	const ExpertAndLogo = () => (
		<div className={clsx(topAlignExpertDetails ? "mb-5" : "mt-14")}>
			<div className="inline text-[#444638]">
				{showTitleAboveName ?
					<>
						<p className="text-base/5 m-0">{expertTitle}</p>
						<p className="text-base/5 font-boldParagraph m-0">{expertName}</p>
					</> :
					<>
						<p className="text-base/5 font-boldParagraph m-0">{expertName}</p>
						<p className="text-base/5 m-0">{expertTitle}</p>
					</>}
			</div>
			{logo && <Image className="max-w-28 md:max-w-40 mt-4" image={logo} alt={logo?.alt} />}
		</div>
	);

	return (
		<div className={
			clsx("mx-auto lg:px-16 h-fit flex flex-col gap-5 items-center !bg-cover",
				isSlider ? "md:w-10/12 px-4" : "md:w-3/4 px-12 my-20 py-12",
				(constrainedWidth || isSlider) ? " w-11/12 rounded-3xl" : "!w-full"
			)} style={{ ...(bgImage && { background: `url(${bgImage})` }), backgroundColor: getRgba(bgColor) }}>
			{title && <h2 className="text-center px-2">{formatTitle(title)}</h2>}
			<div className={
				clsx("flex flex-col justify-center lg:gap-20 items-center",
					imageRight ? "lg:flex-row" : "lg:flex-row-reverse", contentTop ? "gap-10" : "gap-0")}>
				<div className="text-left max-w-xl">
					{topAlignExpertDetails &&
						<div className="hidden lg:inline">
							<ExpertAndLogo />
						</div>}
					{!hideDoubleQuote &&
						<img className={
							clsx("w-10 mb-16",
								!contentTop && "lg:block hidden")} src={DoubleQuote} alt="" role="presentation" aria-hidden="true" />}
					<p className={
						clsx("text-center lg:text-left", largerFont ? "text-2xl/7" : "text-lg", !contentTop && "lg:block hidden")}>
						{quote}
					</p>
					{!topAlignExpertDetails && <div className="hidden lg:block"> <ExpertAndLogo /> </div>}
				</div>
				<Image className={clsx("lg:max-w-[18rem]", !showOriginalImg && "rounded-xl")} image={img} alt={img.alt} />
				<div className={clsx("inline lg:hidden", isSlider ? "text-left" : "text-center")}>
					{!hideDoubleQuote &&
						<img className={clsx("w-10 mb-10 -mt-3.5 z-10 relative", contentTop && "hidden")}
							src={DoubleQuote} alt="" role="presentation" aria-hidden="true" />}
					<p className={clsx(largerFont ? "text-2xl/7" : "text-lg", contentTop && "hidden")}>{quote}</p>
					<ExpertAndLogo />
				</div>
			</div>
		</div>
	);
};

export default ExpertQuote;